<script lang="ts" setup>
import { ref } from 'vue';
import storePolicy from '@store/policy';
import { validationRFC } from '../../../../../helpers';
import { findClientByTributaryCode } from '@repositories/landing.repository';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const props = defineProps<{ companySelectedByParams: any, inputsHidden: boolean }>();
const emit = defineEmits(['submitRFC']);

const store = storePolicy();
const fieldsForm1: any = ref([
  {
    key: 'rfc',
    title: t('landing.forms.form_rfc_mx.rfc_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
    },
    placeholder: t('landing.forms.form_rfc_mx.rfc_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding text-uppercase',
    hidden: false,
    formatValue: (e: string) => e?.toUpperCase() ?? '',
    errors: [],
  },
]);

const handleOnSubmitRFC = async (e: any) => {
  const isValidRfc = validationRFC(e.items.rfc);
  if (!e.isFormValid || !isValidRfc) {
    return (fieldsForm1.value[0].errors = ['rfc es invalido']);
  }

  const { locations, client } = await findClientByTributaryCode(e.items.rfc);

  if (client) {
    store.setProp({ key: 'client', value: client });
  }

  if (locations && client) {
    const updatesClientInputs = [
      { key: 'tradeName', value: client.tradeName },
      { key: 'phone1', value: client.phone1 },
      {
        key: 'companyGPSId',
        value: {
          id: props.companySelectedByParams?.id ?? client.companyGPS.id,
          nombre:
            props.companySelectedByParams?.nombre ??
            client.companyGPS.description,
        },
      },
      { key: 'address', value: client.address },
      { key: 'postCode', value: client.postCode },
      {
        key: 'colony',
        options: locations,
        value: {
          id: client.neighborhood.id,
          nombre: client.neighborhood.description,
        },
      },
      { key: 'city', value: client.city.description },
      { key: 'state', value: client.state.description },
    ];
	fieldsForm1.value.find((field: any) => field.key === 'rfc').disabled = true;
	return emit('submitRFC', {rfc: e.items.rfc, updatesClientInputs, client});
  }
  emit('submitRFC', {rfc: e.items.rfc});
};
</script>

<template>
  <Form :inputs="fieldsForm1" @onSubmit="handleOnSubmitRFC">
    <template #buttons>
      <div class="d-flex" v-if="inputsHidden">
        <CButton
          class="p-4 w-100 my-2 px-2"
          background="background-green"
          style="font-size: 1rem"
        >
          <template #content>{{ t('landing.forms.form_rfc_mx.comprobar_rfc') }}</template>
        </CButton>
      </div>
    </template>
  </Form>
</template>
